import Formsy from 'formsy-react';

// This is the place you should write custom validators
Formsy.addValidationRule('isNotLength', function(values, value, array) {
  if (!value) {
    return array[0] >= 0;
  }

  if (value.length >= array[0] && value.length <= array[1]) {
    return false;
  }

  return true;
});

Formsy.customValidators = {};

Formsy.customValidators.isRequired = function(values, value) {
  return value === null || value === undefined || value === '';
};

Formsy.customValidators.isGreaterThan = function(values, value, min) {
  return Number(value) > min;
};

Formsy.customValidators.isLessThan = function(values, value, max) {
  return Number(value) < max;
};

Formsy.customValidators.isValidEventAmount = function(values, value, min) {
  if (Number(value) === 0 || value === undefined || value === null) {
    return true;
  }
  return Number(value) > min;
};


Formsy.customValidators.isGreaterOrEqualToDate = function(values, value, minDate) {
  if (!(value instanceof Date)) {
    return false;
  }

  const clonedDate = new Date(value.getTime());
  const clonedMinDate = new Date(minDate.getTime());

  return clonedDate.setHours(0, 0, 0, 0) >= clonedMinDate.setHours(0, 0, 0, 0);
};

Formsy.customValidators.isValidAccountNumber = function(value, name, currency) {
  if (window.Stripe) {
    return window.Stripe.bankAccount.validateAccountNumber(value.account_number, currency);
  }
  return true;
};

Formsy.customValidators.isValidRoutingNumber = function(value, name, currency) {
  if (window.Stripe) {
    return window.Stripe.bankAccount.validateRoutingNumber(value.routing_number, currency);
  }
  return true;
};

Formsy.customValidators.isEmail = function(values, value) {
  return /^([\w\.%\+\-']+)@([\w\-]+\.)+([\w]{2,})$/i.test(value);
};

Formsy.customValidators.isEmailWithSpaces = function(values, value) {
  return Formsy.customValidators.isEmail(values, value.trim());
};

Formsy.customValidators.couldPlausiblyBeANorthAmericanPhoneNumber = function(values, value) {
  return !!value && /^\+?1?[- .]?\(?\d{3}\)?[- .]?\d{3}[- .]?\d{4}$/m.test(value);
};

Formsy.customValidators.isEmailOrPhone = (values, value) => {
  if (!value) {
    return 'Email address or phone number required';
  }
  if (value.indexOf('@') >= 0) {
    return Formsy.customValidators.isEmailWithSpaces(null, value) ? true : 'Invalid email address';
  } else {
    return Formsy.customValidators.couldPlausiblyBeANorthAmericanPhoneNumber(null, value) ? true :
      'Invalid email address or phone number';
  }
};

Formsy.customValidators.isEmailOrPhoneOrFormIsEmpty = (values, value) => {
  if (values.name || value) {
    return Formsy.customValidators.isEmailOrPhone(values, value);
  }
  return true;
};

Formsy.customValidators.isPresentIfUidIsPresent = (values, value) => {
  if (value && value.trim().length > 0) {
    return true;
  }
  return values.uid ? false : !value;
};

// We override Formsy's built-in isEmail with out own method that uses the same pattern used by API.
Formsy.addValidationRule('isEmail', Formsy.customValidators.isEmail);
Formsy.addValidationRule('isEmailWithSpaces', Formsy.customValidators.isEmailWithSpaces);
Formsy.addValidationRule('isEmailOrPhone', Formsy.customValidators.isEmailOrPhone);
Formsy.addValidationRule('couldPlausiblyBeANorthAmericanPhoneNumber',
  Formsy.customValidators.couldPlausiblyBeANorthAmericanPhoneNumber);
Formsy.addValidationRule('isValidAccountNumber', Formsy.customValidators.isValidAccountNumber);
Formsy.addValidationRule('isValidRoutingNumber', Formsy.customValidators.isValidRoutingNumber);
Formsy.addValidationRule('isValidEventAmount', Formsy.customValidators.isValidEventAmount);
Formsy.addValidationRule('isGreaterOrEqualToDate', Formsy.customValidators.isGreaterOrEqualToDate);
Formsy.addValidationRule('isRequired', Formsy.customValidators.isRequired);
Formsy.addValidationRule('isGreaterThan', Formsy.customValidators.isGreaterThan);
Formsy.addValidationRule('isLessThan', Formsy.customValidators.isLessThan);

export default Formsy;



// WEBPACK FOOTER //
// ./src/lib/Formsy.js